import { styled } from '@mui/material/styles'
import { SvgIconProps } from '@mui/material'
import {
  ArrowDownward as ArrowDownwardIcon,
  ExpandMore as ExpandMoreIcon,
  PushPinOutlined as PushPinOutlinedIcon,
} from '@mui/icons-material'

export type RotationalIconProps = SvgIconProps & {
  degrees?: number
}

export const RotationalArrowDownwardIcon = styled(
  ({ degrees = 0, ...others }: RotationalIconProps): JSX.Element => (
    <ArrowDownwardIcon {...others} />
  ),
  {
    shouldForwardProp: (prop) => prop !== 'degrees',
  },
)(({ theme, degrees }) => ({
  transform: `rotate(${degrees}deg)`,
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}))

export const RotationalExpandMoreIcon = styled(
  ({ degrees = 0, ...others }: RotationalIconProps): JSX.Element => <ExpandMoreIcon {...others} />,
  {
    shouldForwardProp: (prop) => prop !== 'degrees',
  },
)(({ theme, degrees }) => ({
  transform: `rotate(${degrees}deg)`,
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}))

export const RotationalPushPinOutlinedIcon = styled(
  ({ degrees = 0, ...others }: RotationalIconProps): JSX.Element => (
    <PushPinOutlinedIcon {...others} />
  ),
  {
    shouldForwardProp: (prop) => prop !== 'degrees',
  },
)(({ theme, degrees }) => ({
  transform: `rotate(${degrees}deg)`,
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}))
